import { create } from "zustand"
import { devtools, persist, createJSONStorage } from "zustand/middleware"
import { useShallow } from "zustand/react/shallow"
import { isDevtoolEnabled } from "@tm/utils"
import { zustandSessionStorage } from "../sessionStorage"
import { replacer, reviver } from "../sessionStorage/helper"
import { createDutchOrderPlatesSlice, DutchOrderPlatesSlice } from "./dutch-order-plates"
import { createManagerSlice, ManagerSlice } from "./manager"

export type DutchOrderPlatesStore = DutchOrderPlatesSlice & ManagerSlice

export const dutchOrderPlatesStore = create<DutchOrderPlatesStore>()(
    devtools(
        persist(
            (set, get, ...a) => ({
                ...createDutchOrderPlatesSlice(set, get, ...a),
                ...createManagerSlice(set, get, ...a),
            }),
            {
                name: "DutchOrderPlatesStore",
                skipHydration: true,
                storage: createJSONStorage(() => zustandSessionStorage, { replacer, reviver }),
            }
        ),
        { name: "Dutch Order Plates Store", enabled: isDevtoolEnabled() }
    )
)

export const useDutchOrderPlatesStore = <T>(selector: (state: DutchOrderPlatesStore) => T): T => {
    return dutchOrderPlatesStore(useShallow(selector))
}
